module.exports = __webpack_public_path__ + "img/wave-bot.2dbf4da9.png";